module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/footer/footer.component.css
// module id = ./src/app/components/shared/footer/footer.component.css
// module chunks = main